import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from '../admin/admin.component';
import { OtherPlanningComponent } from './other-planning/other-planning.component';
import { DailyClassPlanningComponent } from './daily-class-planning/daily-class-planning.component';
import { LessonPlanningComponent } from './lesson-planning/lesson-planning.component';
import { ActivityTypeComponent } from './activity-type/activity-type.component';


const routes: Routes = [
  {
    path: '',
    component: AdminComponent,
    children: [
       { path: 'activitytype', component: ActivityTypeComponent, pathMatch: 'full' },
       { path: 'lessonplanning', component: LessonPlanningComponent, pathMatch: 'full' },
       { path: 'dailyclassplanning', component: DailyClassPlanningComponent, pathMatch: 'full' },
       { path: 'otherplanning', component: OtherPlanningComponent, pathMatch: 'full' },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LessonplanRoutingModule { }
